import { PublicWebRedirect } from '@/features/public-web/PublicWebRedirect';
import { APP_CONFIG } from '@/lib/app/config';

export default function TermsWebScreen() {
  return <PublicWebRedirect label="Terms of Service" targetURL={APP_CONFIG.termsURL} />;
}
